// Rolling window used for the hot topic overview table (volume, fact-checked, to-review counts)
// and the Review modal. Change this one value to adjust the window everywhere - the column
// header and the review modal's volume chip both read it, so no label needs editing too.
export const HOT_TOPIC_OVERVIEW_WINDOW_DAYS = 7;

// Fallback topic name used when a question doesn't fit any defined topic, regardless of mode.
export const HOT_TOPIC_FALLBACK_NAME = 'Undefined';
export const HOT_TOPIC_FALLBACK_NAMES = [HOT_TOPIC_FALLBACK_NAME];

export const PRE_APPROVAL_SIMILARITY_THRESHOLD = 0.85;

// Shared enum for hot topic source — whether a topic was defined by an admin
// (predefined) or discovered by the LLM at call time (ai).
// Values intentionally match HotTopicsMode so the same string is used for both
// the per-document source and the per-studio operating mode.
export enum HotTopicsMode {
  AI = 'ai',
  PREDEFINED = 'predefined',
}

// Review-state filter for the hot topic conversation endpoints.
// UNREVIEWED backs the "Review" flow (pending questions), PRE_APPROVED backs the
// pre-approved preview opened from the progress bar, ALL returns both.
export enum HotTopicConversationFilter {
  ALL = 'all',
  UNREVIEWED = 'unreviewed',
  PRE_APPROVED = 'pre-approved',
}
